import React from 'react';
import { Card, Tabs } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import Videosection from "./VideoSction";

const SettingsDashboard = () => {
  const items = [
    {
      key: '1',
      children: (
        <div className="p-4">
          <Videosection />
        </div>
      ),
    },
  ];

  return (
    <div className="h-full overflow-auto">
      <div className="p-6">
        <div className="settings-dashboard">
          <div className="mb-4">
            <div>
              <h2 className="text-2xl font-bold">
                <SettingOutlined className="mr-2" />
                CMS Dashboard
              </h2>
              <p className="text-gray-600">Manage your CMS configurations with no worries</p>
            </div>
          </div>

          <Card className="shadow-sm">
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="settings-tabs"
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SettingsDashboard;